<template>
    <v-dialog v-model="deleteResidenceTermsDialog" max-width="540">
        <template v-slot:activator="{ on, attrs }">
            <v-btn :color="dangerColor" icon v-bind="attrs" v-on="on">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                            mdi-delete
                        </v-icon>
                    </template>
                    <span>Remove</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Remove Residence Term
            </v-card-title>
            <v-card-text>
                Are you sure you would like to remove <b>{{ item.term }}</b>? This action can not
                be
                undone! Please click confirm to proceed.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn ref="confirmBtn" :color="dangerColor" text @click="removeResidenceTerms()">
                    Confirm
                </v-btn>
                <v-btn :color="warningColor" text @click="closeDialog()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'meal-plan-delete',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            deleteResidenceTermsDialog: false
        }
    },
    methods: {
        closeDialog() {
            this.deleteResidenceTermsDialog = false;
        },
        removeResidenceTerms() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?deleteEntity`;
            let term = this.item.term;

            // Set loader
            that.$refs.confirmBtn.loading = true;

            // Parse array into string
            formData.append('id', this.item.id);
            formData.append('mode', 'deleteEntity');
            formData.append('type', 'ResidenceTerms');

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${term} has been successfully removed.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${term} could not be removed. ${json.message}.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                });
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>